import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/(auth)/login/page.tsx");
